/**
 * PKCE (Proof Key for Code Exchange) utilities for Spotify OAuth
 * https://tools.ietf.org/html/rfc7636
 */

/**
 * Generates a code_verifier for PKCE
 * Must be a cryptographically random string using the unreserved characters
 * [A-Z] / [a-z] / [0-9] / "-" / "." / "_" / "~"
 * Minimum length: 43 characters, Maximum length: 128 characters
 */
export function generateCodeVerifier(): string {
  const length = 128
  let text = ''
  const possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-._~'

  for (let i = 0; i < length; i++) {
    text += possible.charAt(Math.floor(Math.random() * possible.length))
  }
  return text
}

/**
 * Generates a code_challenge from a code_verifier
 * This is the base64url encoded SHA256 hash of the code_verifier
 */
export async function generateCodeChallenge(verifier: string): Promise<string> {
  const encoder = new TextEncoder()
  const data = encoder.encode(verifier)
  const digest = await crypto.subtle.digest('SHA-256', data)
  
  // Convert ArrayBuffer to base64url string
  // base64url is base64 with '+' replaced by '-' and '/' replaced by '_', and padding removed
  const base64 = btoa(String.fromCharCode(...new Uint8Array(digest)))
  return base64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '')
}

